export enum KeyCodes {
    ENTER = 'ENTER',
    SPACE = 'SPACE',
    BACKSPACE = 'BACKSPACE',
    TAB = 'TAB',
    CAPS_LOCK = 'CAPS_LOCK',
    ESC = 'ESC',
    PAGE_UP = 'PAGE_UP',
    PAGE_DOWN = 'PAGE_DOWN',
    END = 'END',
    HOME = 'HOME',
    LEFT = 'LEFT',
    UP = 'UP',
    RIGHT = 'RIGHT',
    DOWN = 'DOWN',
    INSERT = 'INSERT',
    DELETE = 'DELETE',
}

export declare type KeyboardKeys = keyof typeof KeyCodes;

/**
 * @param {string} code
 * @param {string} codeToCompare
 * @returns {boolean}
 */
export function compareKeyCode(code: string, codeToCompare: string): boolean {
    return code.toUpperCase() === codeToCompare.toUpperCase();
}
